// Tracks which page section is in view and highlights the matching item in
// .ecw-sticky-nav with that item's own accent color. Sections are matched by
// the nav item's [data-target] against a section's id attribute
// (set via Elementor Advanced > CSS ID).

function setActive(nav, target) {
  nav.querySelectorAll('.ecw-sticky-nav__item').forEach((item) => {
    item.classList.toggle('is-active', item.dataset.target === target);
  });
}

// Elementor puts this nav in its own thin section, so CSS `position: sticky`
// has nowhere to "stick" once that section scrolls past (see _sticky-nav.scss
// for the full explanation). Pin it as `position: fixed` instead, once the
// page has scrolled far enough that the nav would otherwise pass under the
// header — and insert a spacer of matching height so the page doesn't jump
// when it pins/unpins.
function initPinning(nav) {
  const spacer = document.createElement('div');
  spacer.className = 'ecw-sticky-nav__spacer';
  spacer.setAttribute('aria-hidden', 'true');
  nav.insertAdjacentElement('afterend', spacer);

  let naturalTop = null;

  function measureNaturalTop() {
    const wasPinned = nav.classList.contains('is-pinned');
    if (wasPinned) {
      nav.classList.remove('is-pinned');
      spacer.style.height = '0px';
    }
    naturalTop = nav.getBoundingClientRect().top + window.scrollY;
    if (wasPinned) update();
  }

  function getPinOffset() {
    const header = document.querySelector('.ecw-header');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function update() {
    if (naturalTop === null) return;
    const shouldPin = window.scrollY + getPinOffset() >= naturalTop;
    const isPinned = nav.classList.contains('is-pinned');

    if (shouldPin && !isPinned) {
      spacer.style.height = nav.getBoundingClientRect().height + 'px';
      nav.classList.add('is-pinned');
    } else if (!shouldPin && isPinned) {
      nav.classList.remove('is-pinned');
      spacer.style.height = '0px';
    }
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', () => {
    naturalTop = null;
    measureNaturalTop();
    update();
  }, { passive: true });

  measureNaturalTop();
  update();
}

export function initStickyNavScrollspy() {
  const navs = document.querySelectorAll('[data-ecw-sticky-nav]');
  if (!navs.length) return;

  navs.forEach((nav) => {
    initPinning(nav);

    const items = Array.from(nav.querySelectorAll('.ecw-sticky-nav__item'));
    const sections = items
      .map((item) => ({ item, el: document.getElementById(item.dataset.target) }))
      .filter((entry) => entry.el);

    if (!sections.length) return;

    // Smooth-scroll on click, offset for the sticky header + nav.
    items.forEach((item) => {
      item.addEventListener('click', (e) => {
        const target = document.getElementById(item.dataset.target);
        if (!target) return;
        e.preventDefault();
        const offset = nav.getBoundingClientRect().bottom - nav.getBoundingClientRect().height;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const match = sections.find((s) => s.el === entry.target);
            if (match) setActive(nav, match.item.dataset.target);
          }
        });
      },
      { rootMargin: '-45% 0px -50% 0px', threshold: 0 }
    );

    sections.forEach(({ el }) => observer.observe(el));
    setActive(nav, sections[0].item.dataset.target);
  });
}
